import React from 'react'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'

import {LayoutSize} from '../../../../components-shared/LayoutSizeProvider/types'
import {EXPERIMENTS} from '../../../../utils/constants'
import {ErrorModal} from '../../../../components-shared/ErrorModal'

type Props = {
  isOpen: boolean
  onClose: () => void
  layoutSize: LayoutSize
  errorTitle?: string
  errorMessage?: string
}

const ReserveErrorModal: React.FC<Props> = ({isOpen, onClose, errorTitle, errorMessage}) => {
  const {experiments} = useExperiments()
  const isErrorHandlerIntegrationEnabled = experiments.enabled(EXPERIMENTS.errorHandlerIntegration)
  const {t} = useTranslation()

  const title =
    isErrorHandlerIntegrationEnabled && errorTitle
      ? errorTitle
      : t('uou-reservations.reservations.not-accepting-title')

  const message =
    isErrorHandlerIntegrationEnabled && errorMessage
      ? errorMessage
      : t('uou-reservations.reservations.not-accepting-contact-by-phone')

  return (
    <ErrorModal
      isModalOpen={isOpen}
      title={title}
      text={message}
      ctaButton={t('uou-reservations.reservations.not-accepting-modal-close-button')}
      onClose={onClose}
      onCtaButtonClick={onClose}
    />
  )
}

export default ReserveErrorModal
